import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import authSlice from "./slices/authSlice.js";
import userSlice from "./slices/userSlice.js";
import truckSlice from "./slices/truckSlice.js";
import dashboardSlice from "./slices/dashboardSlice.js";
import categoriesSlice from './slices/categoriesSlice.js';
import servicesSlice from './slices/servicesSlice.js';
import subCategorySlice from './slices/subCategorySlice';
import JobSlice from './slices/jobSlice.js';
import codeSlice from './slices/codeSlice.js';
import timeSlotSlice from './slices/timeSlotSlice.js';
import roleSlice from './slices/roleSlice.js';
import subServiceSlice from './slices/subServiceSlice.js';
import settingSlice from './slices/settingSlice.js';
import chatQuestionSlice from './slices/chatQuestionSlice.js';


const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  auth: authSlice,
  user: userSlice,
  truck: truckSlice,
  dashboard: dashboardSlice,
  categories: categoriesSlice,
  services: servicesSlice,
  subCategory: subCategorySlice,
  jobs: JobSlice,
  code: codeSlice,
  timeSlot: timeSlotSlice,
  role: roleSlice,
  subService: subServiceSlice,
  settings: settingSlice,
  chatQuestion: chatQuestionSlice
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);